const BASE = '/expansao/api'

async function request<T>(path: string, options?: RequestInit): Promise<T> {
  const res = await fetch(`${BASE}${path}`, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    ...options,
  })
  if (res.status === 401) {
    window.location.href = '/?redirect=' + encodeURIComponent(window.location.pathname)
    throw new Error('nao_autenticado')
  }
  if (!res.ok) {
    const body = await res.json().catch(() => ({}))
    throw new Error(body.error || `HTTP ${res.status}`)
  }
  return res.json()
}

export const api = {
  // Boards
  getBoards: () => request<import('./types').Board[]>('/boards'),
  getBoard: (id: number) => request<import('./types').Board>(`/boards/${id}`),

  // Cards
  getCards: (boardId: number) => request<import('./types').Card[]>(`/boards/${boardId}/cards`),
  getCard: (id: number) => request<import('./types').Card & { comentarios: import('./types').Comentario[] }>(`/cards/${id}`),
  createCard: (boardId: number, data: Record<string, unknown>) =>
    request<import('./types').Card>(`/boards/${boardId}/cards`, { method: 'POST', body: JSON.stringify(data) }),
  updateCard: (id: number, data: Record<string, unknown>) =>
    request<import('./types').Card>(`/cards/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  moveCard: (id: number, coluna_id: string, ordem: number) =>
    request<import('./types').Card>(`/cards/${id}/mover`, { method: 'PATCH', body: JSON.stringify({ coluna_id, ordem }) }),
  archiveCard: (id: number) =>
    request<import('./types').Card>(`/cards/${id}/arquivar`, { method: 'PATCH' }),
  deleteCard: (id: number) =>
    request<{ ok: boolean }>(`/cards/${id}`, { method: 'DELETE' }),

  // Comentarios
  addComment: (cardId: number, conteudo: string) =>
    request<import('./types').Comentario>(`/cards/${cardId}/comentarios`, { method: 'POST', body: JSON.stringify({ conteudo }) }),

  // Decisoes
  getDecisoes: () => request<import('./types').Decisao[]>('/decisoes'),
  getDecisao: (id: number) => request<import('./types').Decisao>(`/decisoes/${id}`),
  createDecisao: (data: Record<string, unknown>) =>
    request<import('./types').Decisao>('/decisoes', { method: 'POST', body: JSON.stringify(data) }),
  updateDecisao: (id: number, data: Record<string, unknown>) =>
    request<import('./types').Decisao>(`/decisoes/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  deleteDecisao: (id: number) =>
    request<{ ok: boolean }>(`/decisoes/${id}`, { method: 'DELETE' }),

  // Pesquisas
  getPesquisas: () => request<import('./types').Pesquisa[]>('/pesquisas'),
  getPesquisa: (id: number) => request<import('./types').Pesquisa>(`/pesquisas/${id}`),
  createPesquisa: (data: Record<string, unknown>) =>
    request<import('./types').Pesquisa>('/pesquisas', { method: 'POST', body: JSON.stringify(data) }),
  updatePesquisa: (id: number, data: Record<string, unknown>) =>
    request<import('./types').Pesquisa>(`/pesquisas/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  deletePesquisa: (id: number) =>
    request<{ ok: boolean }>(`/pesquisas/${id}`, { method: 'DELETE' }),

  // Milestones
  getMilestones: () => request<import('./types').Milestone[]>('/milestones'),
  getMilestone: (id: number) => request<import('./types').Milestone>(`/milestones/${id}`),
  createMilestone: (data: Record<string, unknown>) =>
    request<import('./types').Milestone>('/milestones', { method: 'POST', body: JSON.stringify(data) }),
  updateMilestone: (id: number, data: Record<string, unknown>) =>
    request<import('./types').Milestone>(`/milestones/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  deleteMilestone: (id: number) =>
    request<{ ok: boolean }>(`/milestones/${id}`, { method: 'DELETE' }),

  // Dashboard
  getDashboard: () => request<import('./types').DashboardResumo>('/dashboard/resumo'),
}
